import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireCurriculum() {
  const curriculum = [{
    title: 'Vei afla despre tipurile de iubire.',
    desc: 'Nu doar iubirea romantică, ci iubirea de sine, iubirea față de ceilalți și iubirea la nivel spiritual. Descoperi care tip de iubire lipsește din viața ta.'
  }, {
    title: 'Vei învăța cum să te iubești pe tine prin exercițiul oglinzii.',
    desc: 'O tehnică prin care înveți să te privești, să te accepți și să îți spui cu voce tare ceea ce nu ți-a spus nimeni niciodată. E simplu, dar transformator.'
  }, {
    title: 'Vei practica cercul iubirii și exerciții de eliberare a resentimentelor.',
    desc: 'Rănile din trecut nu dispar de la sine. Aici le scoți la lumină, le privești cu compasiune și le eliberezi conștient.'
  }, {
    title: 'Vei descoperi afirmații zilnice de practică pentru iubire.',
    desc: 'Afirmații pe care să le repeți în fiecare zi și care, în timp, îți schimbă modul în care te raportezi la tine și la ceilalți.'
  }, {
    title: 'Vei practica exerciții de iertare și reconectare prin iubire.',
    desc: 'Iertarea nu e pentru cel care te-a rănit. E pentru tine. Aici înveți cum să ierți cu adevărat și cum să te reconectezi la o stare de pace.'
  }, {
    title: 'Vei experimenta meditații ghidate pentru creșterea vibrației și iubirea divină.',
    desc: 'Meditații prin care accesezi o stare de iubire profundă, liniște și conectare pe care mulți participanți o descriu ca fiind diferită de orice au simțit până acum.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-1437">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1438">
        <SectionHeading title="Ce vei descoperi în cursul Abundența Iubirii" data-id="element-1439" />

        <div className="space-y-5 mb-16" data-id="element-1440">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-1441">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-1442">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-1443" />
              </div>
              <div data-id="element-1444">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-1445">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1446">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1447">
          <CTAButton data-id="element-1448" />
        </motion.div>
      </div>
    </section>;
}